import script from "./ControlPanelItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlPanelItem.vue?vue&type=script&setup=true&lang=ts"

import "./ControlPanelItem.vue?vue&type=style&index=0&id=2e822cb8&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e822cb8"]])

export default __exports__